import { defaultCrudMessages } from "../shared/crud/simple-crud";

export const messages = {
  ...defaultCrudMessages,
  entityName: { id: "display.entityName", defaultMessage: "Display" },
  create: { id: "display.create", defaultMessage: "Crear display" },
  edit: { id: "display.edit", defaultMessage: "Editar" },
  duplicate: { id: "display.duplicate", defaultMessage: "Duplicar" },
  drag: { id: "display.drag", defaultMessage: "Reordenar" },
  video: { id: "display.video", defaultMessage: "Video" },
  image: { id: "display.image", defaultMessage: "Imagen" },
  html: { id: "display.html", defaultMessage: "HTML" },
  locationProperty: { id: "display.locationProperty", defaultMessage: "Propiedad" },
  locationAccommodation: { id: "display.locationAccommodation", defaultMessage: "Alojamiento" },
  active: { id: "display.active", defaultMessage: "Activo" },
  displayTicker: { id: "display.ticker", defaultMessage: "Identificador" },
  presenceValidator: { id: "display.presenceValidator", defaultMessage: "Campo obligatorio" },
  tickerValidation: { id: "display.tickerValidation", defaultMessage: "Formato inválido" },
  maxLengthTickerValidator: { id: "display.maxLength", defaultMessage: "Longitud máxima superada" },
  name: { id: "translation.name", defaultMessage: "Nombre" },
  description: { id: "translation.description", defaultMessage: "Descripción" },
  translations: { id: "translation.translations", defaultMessage: "Traducciones" },
  scope: { id: "display.scope", defaultMessage: "Display" },
  activeHelp: { id: "display.active.help", defaultMessage: "¿Es visible el display en el motor?" },
  tabsErrors: {
    id: "translation.tabsErrors",
    defaultMessage: "Faltan campos obligatorios en traducciones",
  },
  tableHeaders: {
    active: { id: "display.header.active", defaultMessage: "Activo" },
    ticker: { id: "display.header.ticker", defaultMessage: "Id" },
    label: { id: "display.header.label", defaultMessage: "Nombre" },
    visible: { id: "display.header.visible", defaultMessage: "Visible" },
    entityFilter: { id: "display.header.entityFilter", defaultMessage: "Ubicación" },
    tickerFilter: { id: "display.header.tickerFilter", defaultMessage: "Mostrar para" },
    contentType: { id: "display.header.contentType", defaultMessage: "Tipo de contenido" },
    position: { id: "display.header.position", defaultMessage: "Orden" },
    actions: { id: "display.header.actions", defaultMessage: "Acciones" },
  },
  period: { id: "display.period", defaultMessage: "Período de visualización" },
  startDate: { id: "display.startDate", defaultMessage: "Fecha inicio" },
  endDate: { id: "display.endDate", defaultMessage: "Fecha fin" },
  contentType: { id: "display.contentType", defaultMessage: "Tipo de contenido" },
  defaultOption: { id: "display.defaultOption", defaultMessage: "Se abre por defecto" },
  save: { id: "display.save", defaultMessage: "Guardar" },
  goBack: { id: "display.goBack", defaultMessage: "Volver" },
  editing: { id: "display.editing", defaultMessage: "Editando display existente" },
  type: { id: "display.type", defaultMessage: "Tipo" },
  tickerFilter: {
    id: "display.tickerFilter",
    defaultMessage: "Mostrar sólo para los siguientes identificadores (separados por comas)",
  },
  defaultOptionHelp: {
    id: "display.defaultOption.help",
    defaultMessage:
      "Activa esta opción para mostrar esta entidad en primer lugar, en lugar de la información del establecimiento/alojamiento.",
  },
  imagesHelpText: {
    id: "display.imagesHelpText",
    defaultMessage:
      "Las imágenes deben tener una resolución de 1900 x 1080 píxeles y un tamaño máximo de 4MB.\n" +
      "El límite es de 10 imágenes.\n" +
      "Formatos válidos: png, jpeg o jpg.\n" +
      "Los nombres de los archivos no pueden contener caracteres especiales, únicamente se pueden usar letras y números.",
  },
  propertiesTabValidator: {
    id: "display.propertiesTabValidator",
    defaultMessage: "Revisa los errores en la gestión de imágenes.",
  },
  saving: { id: "display.saving", defaultMessage: "Guardando..." },
  saveError: {
    id: "display.saveError",
    defaultMessage: "Error al guardar",
  },
};
